"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "sanitiseUserObj", {
    enumerable: true,
    get: function() {
        return sanitiseUserObj;
    }
});
const ignoreKeys = new Set([
    'password',
    'salt',
    'invite_token',
    'invite_token_expires',
    'reset_password_expires',
    'reset_password_token',
    'email_verification_token',
    'created_at',
    'updated_at'
]);
function sanitiseUserObj(user) {
    return Object.entries(user).reduce((obj, [key, value])=>{
        if (ignoreKeys.has(key)) return obj;
        obj[key] = value;
        return obj;
    }, {});
}
